// @flow

import { combineReducers } from 'redux';
import type { Reducer } from 'redux';
import { createReducer } from 'redux-act';

import type { ResourceAction } from '@gandi/resource/redux';

import type { FullState } from 'src/types';

import {
  documentResource,
  jurisdictionsResource,
  resource,
  smdResource,
} from './actions';

const initialState = {
  documents: [],
  prices: [],
  jurisdictions: [],
  smd: [],
};

const smdReducer: {
  (): (state: Array<any>, payload?: mixed, meta?: mixed) => Array<any>,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<Array<any>>,
  options: () => mixed,
  ...
} = createReducer(
  {
    [smdResource.fetch.success.getType()]: function handleFetchSmdSuccess(
      state,
      { response, label },
    ) {
      return {
        ...state,
        [label]: response.data,
      };
    },
  },
  initialState.smd,
);

const jurisdictionsReducer: {
  (): (state: Array<any>, payload?: mixed, meta?: mixed) => Array<any>,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<Array<any>>,
  options: () => mixed,
  ...
} = createReducer(
  {
    [jurisdictionsResource.fetch.success.getType()]:
      function handleFetchPricesSuccess(state, { response }) {
        return response.data.map(jurisdiction => ({
          value: jurisdiction.code,
          text: jurisdiction.name_label,
        }));
      },
  },
  initialState.jurisdictions,
);

const tmchReducer: {
  (): (state: Array<any>, payload?: mixed, meta?: mixed) => Array<any>,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<Array<any>>,
  options: () => mixed,
  ...
} = createReducer(
  {
    [resource.fetch.success.getType()]: function handleFetchPricesSuccess(
      state,
      { response },
    ) {
      return response.data;
    },
  },
  initialState.prices,
);

const documentsReducer: {
  (): (state: Array<any>, payload?: mixed, meta?: mixed) => Array<any>,
  assignAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  batch: ({ ... } | Array<mixed>) => mixed,
  bindAll: ({ ... } | Array<mixed>, { ... } | Array<mixed>) => mixed,
  disbatch: (mixed, void | Array<mixed>) => mixed,
  has: (actionCreator: mixed) => boolean,
  // $FlowFixMe[cannot-resolve-name]
  off: Reducer$Off,
  // $FlowFixMe[cannot-resolve-name]
  on: Reducer$On<Array<any>>,
  options: () => mixed,
  ...
} = createReducer(
  {
    [documentResource.post.success.getType()]:
      function handlePostDocumentsSuccess(state, { response, label }) {
        return {
          ...state,
          [label]: response.data.id,
        };
      },
  },
  initialState.documents,
);

export default (combineReducers({
  documents: documentsReducer,
  prices: tmchReducer,
  jurisdictions: jurisdictionsReducer,
  smd: smdReducer,
}): Reducer<FullState['tmch'], ResourceAction<>>);
